<template>
    <div v-if="ready">
            <div class="md-layout md-layout-item ">
                <md-avatar class="md-avatar-icon md-large md-primary" >
                    <img v-if="url" :src="url" @click="showDialog = true" />
                    <img v-if="content" :src="content" @click="showDialog = true" />
                </md-avatar>
                <md-button v-if="!isReadOnly"  @click="onEdit()" class="md-icon-button md-primary md-dense " :disabled="isReadOnly"  >
                    <md-icon>edit</md-icon>
                </md-button>                        
                <input ref="hiddenFileInput" type="file" accept="image/jpeg" @change="onChange" hidden>

                <md-dialog id="dcb9c367-9750-44b2-bbcc-61b763b1e9d6" :md-active.sync="showDialog">
                    <img v-if="url" :src="url" />
                    <img v-if="content" :src="content" />
                    <md-dialog-actions>
                        <md-button class="md-primary" @click="showDialog = false">Fermer</md-button>
                    </md-dialog-actions>
                </md-dialog>
            </div>

    </div>
</template>
<style>
    #dcb9c367-9750-44b2-bbcc-61b763b1e9d6 img {
        max-height: 600px;
    }    
    #dcb9c367-9750-44b2-bbcc-61b763b1e9d6 .md-dialog-container {
        min-height: 650px;
    }
</style>
<style scoped>
    .md-avatar {
        margin: 0px;
        /* width: 100px;
        height: 100px; */
    }    
</style>
<script>
    //import { apiExtension } from '@/mixins/apiExtension.js';
    // type = 'Picture' | 'Image'
    export default {
        name: 'field-image-wd',
        mixins: [],
        props: {
            item: Object,
            defaultImage: String,
            property: String,
            type: String,
            readonly: Boolean
        },

        data: () => ({
            val: null,
            itemWatch: null,
            showDialog: false

        }),
        watch: {
            val: {
                handler(e) {
                    if(this.item != null) {
                        this.item[this.property] = e;
                    }
                }
            }
        },
        computed:{
            ready: async function () {
                let show = false;
                if(this.item != null) {
                    if(this.item[this.property] == null) {
                        //if(this.defaultValue != null) { this.val = this.defaultValue; }
                    } else {
                        this.val = this.item[this.property];
                    }

                    if(!this.itemWatch) {
                        this.itemWatch = this.$watch('item.' + this.property, this.onItemChanged );
                    }                    

                    show = true;
                }
                return show;
            },
            url: function() {
                if(this.item && this.item[this.property] ) {
                    return this.item[this.property].url;
                } else {
                    return null;
                }
            },
            content: function() {
                if(this.item && this.item[this.property] ) {

                    var vm = this.item[this.property];
                    if(typeof vm === 'object' && vm !== null) {
                        return this.item[this.property].content;
                    } else {
                        return this.item[this.property];
                    }
                    
                } else {
                    return null;
                }
            },
            isReadOnly: function() {
                return this.readonly; // || !this.isEdit;
            },


        },
        mounted: async function () {
            //await this.dataSourceRead();
        },
        methods: {
            // onClear: function(){
            //     if(!this.isReadOnly){
            //         if(this.item != null) { 
            //             this.item[this.property] = this.defaultValue; // null;
            //         }
            //         this.val = this.defaultValue;
            //     }
            // },
            onChange(e) {
                const fileSelected = e.target.files[0];
                // to keep view model object available in pure javascript...
                var vm = this.item[this.property];
                if(typeof vm === 'object' && vm !== null){
                    vm.path = fileSelected.name;
                    if (this.type && this.type.toLowerCase() == 'image') {
                        ImageFileOptimizeToDataURL(fileSelected, function (dataURL) {
                            vm.encoding = 'DataUrl';
                            vm.content = dataURL;
                        });
                    } else {
                        PictureFileOptimizeToDataURL(fileSelected, function (dataURL) {
                            vm.encoding = 'DataUrl';
                            vm.content = dataURL;
                        });
                    }
                }
                else {
                    var self = this;
                    PictureFileOptimizeToDataURL(fileSelected, function (dataURL) {
                            self.item[self.property] = dataURL;
                    });
                }

            },
            onEdit() {
                this.$refs.hiddenFileInput.click();
            },

            onItemChanged : function(newVal, oldVal ) {
                //console.log('watch item...');
                // if(!this.isReadOnly) {
                //     if(this.val != newVal) { 
                //         this.val = newVal;
                //     } 
                // }
            }
                
        }
    }

</script>